// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/produtos/services/produtoService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  ProdutoListItem,
  ProdutoDetalheApi,
  CriarProdutoRequest,
  PaginatedProdutos,
} from '../types';

const BASE = '/api/produtos';

export interface ProdutoListFiltros {
  termo?: string;
  tipoProduto?: number;
  grupoId?: number;
  situacao?: 'ativos' | 'inativos';
  ordenarPor?: 'codigo' | 'descricao';
  decrescente?: boolean;
}

export async function fetchProdutos(
  pagina = 1,
  tamanhoPagina = 20,
  filtros: ProdutoListFiltros = {},
): Promise<PaginatedProdutos> {
  const { data } = await apiClient.get<PaginatedProdutos>(BASE, {
    params: { pagina, tamanhoPagina, ...filtros, termo: filtros.termo || undefined },
  });
  return data;
}

export async function fetchProdutoById(id: string | number): Promise<ProdutoDetalheApi> {
  const { data } = await apiClient.get<ProdutoDetalheApi>(`${BASE}/${id}`);
  return data;
}

export async function searchProdutos(termo: string): Promise<ProdutoListItem[]> {
  const { data } = await apiClient.get<ProdutoListItem[]>(`${BASE}/buscar`, {
    params: { termo },
  });
  return data;
}

export async function fetchProdutoPorCodigoBarras(codigo: string): Promise<ProdutoDetalheApi> {
  const { data } = await apiClient.get<ProdutoDetalheApi>(`${BASE}/codigo-barras/${codigo}`);
  return data;
}

export async function createProduto(produto: CriarProdutoRequest): Promise<ProdutoDetalheApi> {
  const { data } = await apiClient.post<ProdutoDetalheApi>(BASE, produto);
  return data;
}

export async function updateProduto(
  id: string | number,
  produto: Partial<CriarProdutoRequest>,
): Promise<ProdutoDetalheApi> {
  const { data } = await apiClient.put<ProdutoDetalheApi>(`${BASE}/${id}`, produto);
  return data;
}

export async function deleteProduto(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`);
}
